export default "__VITE_ASSET__BY75Ixw3__"